"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apiService_1 = __importDefault(require("@common/services/apiService"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var analyzeRule_1 = require("../../analyzeRule");
var RuleConditionItem_1 = __importDefault(require("../RuleConditionItem"));
var Button_1 = __importDefault(require("@/react-app/common/components/Button"));
function RuleConditions(_a) {
    var _this = this;
    var expression = _a.expression, domain = _a.domain, isSubmitted = _a.isSubmitted, updateRuleExpression = _a.updateRuleExpression, domainBlangVariables = _a.domainBlangVariables, dictionaries = _a.dictionaries;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = __read((0, react_1.useState)([]), 2), rules = _b[0], setRules = _b[1];
    // console.log('rules state', rules)
    var confusableDictionaries = dictionaries.filter(function (item) { return item.kind === 'CONFUSABLE'; });
    var mixedDictionaries = dictionaries.filter(function (item) { return item.kind === 'MIXED'; });
    /**
     * parseBlangExpression
     * @Description: Parse blang expression to an array of rules, Split by the conjunction word "AND" and "OR"
     * @variable
     * rules: Get the rules array
     * containsOR: the blang contains "OR" or not
     * hasArrayValues: the blang has an array of values
     * containsLENGTH: the blang contains "LENGTH" or not
     * isUsingCONTAINSWithOccurrences: the blang editor contains CONTAINS [x,y] or CONTAINS {unique=true} [x,y]
     */
    var parseBlangExpression = function () { return __awaiter(_this, void 0, void 0, function () {
        var validateRuleResult, result, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService_1.default.validateBlangRule({ domain: domain }, expression)];
                case 1:
                    validateRuleResult = _c.sent();
                    // validateRuleResult.data.result === false  means that the rule is invalid
                    if (validateRuleResult.data.result === false || !validateRuleResult.data.parsedRule) {
                        return [2 /*return*/, false];
                    }
                    result = {
                        hasComment: validateRuleResult.data.hasComment,
                        analyzedRule: (0, analyzeRule_1.analyzeRule)(validateRuleResult.data.parsedRule),
                    };
                    // console.log('result', result.analyzedRule);
                    if ((_a = result.analyzedRule) === null || _a === void 0 ? void 0 : _a.rules) {
                        setRules((_b = result.analyzedRule) === null || _b === void 0 ? void 0 : _b.rules);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    setRules([]);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var addEmptyRule = function () {
        var emptyRule = {
            sourceData: {
                field: { type: 'variable', value: '' },
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                operator: '',
                value: { type: 'string', value: '' },
            },
            blangExpression: '',
        };
        setRules(__spreadArray(__spreadArray([], __read(rules), false), [emptyRule], false));
    };
    var deleteRule = function (index) {
        var newRules = rules.filter(function (_, i) { return i !== index; });
        var newExpression = newRules.every(function (rule) { return !!rule.blangExpression; })
            ? newRules.map(function (rule) { return rule.blangExpression; }).join(' AND ')
            : '';
        setRules(newRules);
        updateRuleExpression(newExpression);
    };
    // callback when one single rule has updated.
    var onUpdate = function (rule, index) {
        setRules(function (prevRules) {
            var newRules = prevRules.map(function (item, i) { return (i === index ? __assign(__assign({}, item), { blangExpression: rule }) : item); });
            var newExpression = newRules.every(function (rule) { return !!rule.blangExpression; })
                ? newRules.map(function (rule) { return rule.blangExpression; }).join(' AND ')
                : undefined;
            // console.log('newExpression', newExpression);
            updateRuleExpression(newExpression);
            return newRules;
        });
    };
    (0, react_1.useEffect)(function () {
        parseBlangExpression();
    }, [domain]);
    return (react_1.default.createElement("div", { className: "rule-conditions flex-container flex-column" },
        rules.map(function (rule, index) { return (react_1.default.createElement("div", { key: index },
            react_1.default.createElement(RuleConditionItem_1.default, { mixedDictionaries: mixedDictionaries, confusableDictionaries: confusableDictionaries, ruleItem: rule, onUpdate: onUpdate, deleteMe: function () { return deleteRule(index); }, isSubmitted: isSubmitted, blangVariables: domainBlangVariables, index: index }),
            index < rules.length - 1 && (react_1.default.createElement("div", { className: "flex-container dashWrapper" },
                react_1.default.createElement("div", { className: "dash flex-item" }),
                react_1.default.createElement("div", { className: "dash-word" }, t('AUTOMATION.DECISION_RULES.RULE_BUILDER.BASIC_MODE.AND_TEXT')),
                react_1.default.createElement("div", { className: "dash flex-item" }))))); }),
        react_1.default.createElement(Button_1.default, { className: "rule-conditions-add-btn", dataCy: "rule-conditions-add-btn", name: "rule-conditions-add-btn", onClick: addEmptyRule, text: t('AUTOMATION.DECISION_RULES.BTN.ADD_CONDITION') })));
}
exports.default = RuleConditions;
